const $ = require('jquery');
const addressSearch = require('../checkout/addressSearch');

/**
 * Main module for handling address form interactions and UI updates.
 *
 * This module manages the functionality for address forms, including:
 * - Checking for error messages related to address fields.
 * - Handling input events with debounce to prevent excessive server requests.
 * - Managing UI elements such as showing and hiding fields based on user actions.
 * - Handling clicks on list items within address dropdowns to populate address fields.
 * - Toggling visibility of additional fields and updating input field properties.
 */
function init() {
    // Initial setup of DOM elements and variables
    const container = $('#address-container');
    const address1 = $('#dwfrm_profile_address_address1');
    const cityInput = $('#dwfrm_profile_address_city');
    const postalInput = $('#dwfrm_profile_address_postal');
    const shippingIds = [
        '#dwfrm_profile_address_address1',
        '#dwfrm_profile_address_city',
        '#dwfrm_profile_address_postal'
    ];
    const isAddressErrorPresent = addressSearch.checkForErrorMsgSibling(shippingIds);
    const addressInput = $('#addressSearch');
    const showHiddenFields = $('#showHiddenFields');
    const hideFields = $('#hideFields');
    const dropDownList = $('#locations-list');
    const messageField = $('#messageField');
    const debounceDelay = Math.floor(container.data('address-search-delay'));

    // Check if all required address fields are filled or if there are any error messages
    if ((address1.val() && cityInput.val() && postalInput.val()) || isAddressErrorPresent) {
        showHiddenFields.addClass('hidden');
        hideFields.removeClass('hidden');
        const nextSibling = $('#link-container').next();
        addressSearch.updateUIDesign(container, nextSibling);
    }

    /**
     * Document click event handler to hide the locations list when clicking outside the address input or locations list.
     *
     * @param {jQuery.Event} event - The jQuery event object representing the click event.
     */
    $(document).click(function (event) {
        const target = $(event.target);
        const linkContainer = $('.links');

        if (
            !target.is(addressInput) &&
            !target.closest(addressInput).length &&
            !target.is(dropDownList) &&
            !target.closest(dropDownList).length &&
            !target.is(linkContainer) &&
            !target.closest(linkContainer).length
        ) {
            dropDownList.addClass('hidden');
            messageField.addClass('hidden');
        }
    });

    $(document).on('input', '#addressSearch', addressSearch.debouncedHandleInput(debounceDelay));
    $(document).on('click', '#addressSearch', addressSearch.debouncedHandleClick);

    /**
     * Event handler for clicking on list items within the locations list.then extracts relevant input fields to pass to the `handleLiClick` function.
     */
    $(document).on('click', '#locations-list li', function () {
        addressSearch.handleLiClick($(this), address1, cityInput, postalInput, container);
    });

    /**
     * Event handler for the click event on elements with the id `showHiddenFields`.
     * Performs various actions such as hiding the current link, showing a related link, updating input field properties,
     * and toggling the visibility of the next sibling element with the classes `additionalFields, additionalAddress`.
     *
     */
    showHiddenFields.on('click', function (event) {
        event.preventDefault();
        const nextSibling = $(this).parent().next();

        $(this).addClass('hidden');
        hideFields.removeClass('hidden');
        addressSearch.updateUIDesign(container, nextSibling);
    });

    /**
     * Event handler for the click event on elements with the id `hideFields`.
     * Performs various actions such as hiding the current link, showing a related link, updating input field properties,
     * and toggling the visibility of the next sibling element with the classes `additionalFields, additionalAddress`.
     */
    hideFields.on('click', function (event) {
        event.preventDefault();
        const errorField = $('.error-msg');
        const currentPlaceholder = addressInput.attr('placeholder');
        const newPlaceholder = `${currentPlaceholder} *`;
        const nextSibling = $(this).parent().next();
        const classesToToggle = ['additionalFields'];
        const validIcon = $('.show-valid');

        $(this).addClass('hidden');
        showHiddenFields.removeClass('hidden');
        errorField.removeClass('hidden');
        addressInput.addClass('required');
        // Change the placeholder attribute of the input field
        addressInput.attr('placeholder', newPlaceholder.trim());
        $('.required-indicator').removeClass('hidden');
        dropDownList.addClass('hidden');
        messageField.addClass('hidden');
        if (validIcon.hasClass('hidden')) {
            classesToToggle.push('additionalAddress');
        }

        // Toggle all classes in the array
        addressSearch.toggleHiddenClasses(nextSibling, classesToToggle);
    });
}

module.exports = {
    init
};
